// ── 대외비 출입증 (2026-10-16, 서버 services/confidential-lock.service.js) ───────────
//   회사별 대외비 비밀번호를 맞히면 서버가 10분짜리 출입증을 준다. **메모리에만** 둔다 —
//   새로고침·로그아웃하면 사라지고, 대외비 화면(급여 관리·연차정산·흐름)을 모두 떠나면 ConfidentialLockGate 가 지운다.
//   대외비 화면끼리 옮겨 다닐 때는 지우지 않는다(사용자 결정 2026-10-16 a) — 떠난 뒤 잠깐 기다렸다가 다른 대외비 화면이 안 열리면 지운다.
//   apiClient 가 대외비 주소에만 싣고, 서버가 돌려준 새 출입증(10분 연장)으로 바꿔 둔다. 423(잠김)이면 창에 알려 비밀번호 창을 띄운다.

let unlockToken = null;
let openGates = 0;
let clearTimer = null;
const LEAVE_GRACE_MS = 1500;

export const CONFIDENTIAL_LOCKED_EVENT = 'confidential-locked';

export function getConfidentialUnlockToken() { return unlockToken; }
export function setConfidentialUnlockToken(token) { unlockToken = token || null; }
export function clearConfidentialUnlockToken() { unlockToken = null; }

/** 대외비 화면이 열려 있는 동안 잡아 둔다. 돌려받은 함수를 닫힐 때 부르면, 다른 대외비 화면이 곧 안 열릴 때 출입증을 지운다. */
export function holdConfidentialUnlock() {
  openGates += 1;
  if (clearTimer) { clearTimeout(clearTimer); clearTimer = null; }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    openGates = Math.max(0, openGates - 1);
    if (openGates > 0) return;
    clearTimer = setTimeout(() => {
      clearTimer = null;
      if (openGates === 0) unlockToken = null;
    }, LEAVE_GRACE_MS);
  };
}

// 대외비 주소: 급여 관리 · 연차정산 · 흐름(매입 관리 /cashflow/purchases 는 빼고)
//   '/api/admin/payroll-…'(다른 말로 이어지는 주소)은 해당 없음 — 이름 바로 뒤가 '/'·'?'·끝일 때만
const CONFIDENTIAL_PATH = /^\/api\/admin\/(payroll|leave-settlement)(\/|\?|$)|^\/api\/admin\/cashflow(\?|$|\/(?!purchases(\/|\?|$)))/;

export function isConfidentialPath(path) {
  return CONFIDENTIAL_PATH.test(String(path || ''));
}

export function withConfidentialUnlock(path, headers = {}) {
  if (!unlockToken || !isConfidentialPath(path)) return headers;
  return { ...headers, 'X-Confidential-Unlock': unlockToken };
}

export function noteConfidentialResponse(path, response) {
  if (!isConfidentialPath(path) || !response) return;
  const fresh = response.headers?.get?.('x-confidential-unlock');
  if (fresh && unlockToken) unlockToken = fresh; // 지운 뒤 늦게 온 응답으로 되살리지 않는다
  if (response.status === 423 && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CONFIDENTIAL_LOCKED_EVENT));
  }
}
